import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';
import {CustomHttpResponse} from '../model/custom-http-response';

@Injectable({
  providedIn: 'root',
})
export class SiteService {
  host = environment.apiUrl;
  private imageUrlSubject = new BehaviorSubject<string | null>(localStorage.getItem('profileImageUrl'));
  imageUrl$ = this.imageUrlSubject.asObservable();

  constructor(private http: HttpClient,
  ) {
  }


  updateImageUrl(newUrl: string) {
    localStorage.setItem('profileImageUrl', newUrl);
    this.imageUrlSubject.next(newUrl);
  }

  getConfiguration(): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.get<CustomHttpResponse>(`${this.host}/v1/public/configs/restaurant`, {observe: 'response'})

  }

  getConfigsOrder(): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.get<CustomHttpResponse>(`${this.host}/v1/admin/configs/order`, {observe: 'response'})

  }

  updateConfigsOrder(body: any): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.patch<CustomHttpResponse>(
      `${this.host}/v1/admin/configs/order`,
      body,
      {observe: 'response'}
    );
  }

  updateConfiguration(config: any): Observable<HttpResponse<CustomHttpResponse>> {
    return this.http.patch<CustomHttpResponse>(
      `${this.host}/v1/admin/configs/restaurant`,
      config,
      {observe: 'response'}
    );
  }
}
